export const REVIEW_ACTIVITY_DEFAULT_DAYS = 28;

export const REVIEW_ACTIVITY_MAX_DAYS = 366;
